import { render } from "./IndexMain.vue?vue&type=template&id=a5892204&scoped=true"
import script from "./IndexMain.vue?vue&type=script&lang=js"
export * from "./IndexMain.vue?vue&type=script&lang=js"

import "./IndexMain.vue?vue&type=style&index=0&id=a5892204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5892204"]])

export default __exports__